import { Image} from "@chakra-ui/react";
import shortLogo from '../../../../global/styles/images/launchdeck-short-logo-icon.png'

const LaunchdeckShortLogo = ({boxSize}) => {

	return (
		<Image src={shortLogo} alt="Launchdeck Short Logo"  boxSize={boxSize ? boxSize : '1em'} />
	);
};

export default LaunchdeckShortLogo;
